"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _table = _interopRequireDefault(require("./table"));
var _TableHOC = _interopRequireDefault(require("./TableHOC"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Spin = _interopRequireDefault(require("../Spin"));
var _excluded = ["style", "className", "tableClassName", "showHeader", "locale", "emptyText", "zebra", "onRow", "onRowClick", "onRowDoubleClick", "footer", "theme", "locale", "expandable", "rowKey", "loading", "columns"]; // components
// Helpers
// table general styles
// cdn tarafına taşındı. shadowRoot olması sebebi ile buradan import edilemiyor. (import olmuş hali head icerisine bastıgından shadowRoot içerisindeki style kullanımına erişemiyor.)
// Olası style düzenlemesi için import edilen dosyalar yorum satırı olarak bırakıldı.
// import './Styled/table.css';
// import './Styled/table-wrapper.css';
// import './Styled/table-selection.css';
// import './Styled/table-expandable-row.css';
// import './Styled/table-sorter.css';
// import './Styled/table-filter.css';
// import './Styled/table-action.css';
// import './Styled/table-bordered.css';
// import './Styled/table-fixed.css';
// import './Styled/table-size-default.css';
// import './Styled/table-size-xsmall.css';
// // import './Styled/table-size-small.css'; // TODO: Sonradan gözden geçirilecek.
// import './Styled/table-editable.css';
// // component styles
// import './Styled/table-general.css';
// import './Styled/filter-dropdown.css';
// import './Styled/table-footer.css';
// // import './Styled/placeholder-view.css';
// // // import './Styled/size.css'; // TODO: size ile ilgili olan state aktarması yapılacak
// styled components
var TableWrapper = function TableWrapper(props) {
  var style = props.style,
    className = props.className,
    tableClassName = props.tableClassName,
    showHeader = props.showHeader,
    locale = props.locale,
    emptyText = props.emptyText,
    zebra = props.zebra,
    onRow = props.onRow,
    onRowClick = props.onRowClick,
    onRowDoubleClick = props.onRowDoubleClick,
    footer = props.footer,
    theme = props.theme,
    mergedLocale = props.locale,
    expandable = props.expandable,
    rowKey = props.rowKey,
    loading = props.loading,
    columns = props.columns,
    restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('table-wrapper', className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_Spin.default, loading, /*#__PURE__*/_react.default.createElement("div", {
    className: "table-container"
    // prefixCls={props.prefixCls}
    // size={props.size}
    // bordered={props.bordered}
    // empty={!props.data.length}
    // noHeader={!showHeader}
    // zebra={props.expandedRowRender ? false : zebra}
    // theme={theme}
  }, /*#__PURE__*/_react.default.createElement(_table.default, (0, _extends2.default)({}, props, {
    prefixCls: 'ykb-ui-table'
  })))));
};
TableWrapper.defaultProps = {
  data: [],
  className: '',
  size: 'default',
  loading: false,
  bordered: true,
  indentSize: 20,
  locale: {},
  rowKey: 'key',
  showHeader: true,
  sortDirections: ['ascend', 'descend'],
  zebra: false,
  expandable: false,
  rowSelection: null,
  rowStyle: function rowStyle(record, index) {},
  getTableMethods: function getTableMethods(tableMethods) {}
};
TableWrapper.propTypes = {
  data: _propTypes.default.array,
  columns: _propTypes.default.array,
  prefixCls: _propTypes.default.string,
  rowSelection: _propTypes.default.object,
  className: _propTypes.default.string,
  size: _propTypes.default.string,
  loading: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.object]),
  bordered: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  locale: _propTypes.default.object,
  sortDirections: _propTypes.default.array,
  zebra: _propTypes.default.bool,
  rowStyle: _propTypes.default.func,
  rowKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  pagination: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.shape({
    disabled: _propTypes.default.bool,
    current: _propTypes.default.number,
    defaultCurrent: _propTypes.default.number,
    total: _propTypes.default.number,
    pageSize: _propTypes.default.number,
    defaultPageSize: _propTypes.default.number,
    showTotal: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func])
  })]),
  theme: _propTypes.default.object,
  onResize: _propTypes.default.func,
  virtualSettings: _propTypes.default.shape({
    overscan: _propTypes.default.number
  }),
  getTableMethods: _propTypes.default.func
};
var _default = exports.default = TableWrapper;